import React, { Component } from 'react';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import FontIcon from '../../components/fontIcon/FontIcon';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';
import './TemperatureSensorPopup.css';

export default class TemperatureSensorPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			availableTempSensors: [],
			showTempSensorDropdown: false,
			selectedTempSensor: null
		};
	}

	_scanForTempSensors = async () => {
		try {
			const response = await mainAPI.sensor.scan();
			
			this.setState({ 
				availableTempSensors: response.sensors,
				showTempSensorDropdown: true 
			});
			toasts.show('Temperature sensors scanned successfully');
		} catch (error) {
			console.error('Error scanning for temperature sensors:', error);
			toasts.show('Error scanning for temperature sensors');
		}
	};

	_onTempSensorSelect = (sensorId) => {
		const selectedSensor = this.state.availableTempSensors.find(s => s.id === sensorId);
		this.setState({ 
			selectedTempSensor: selectedSensor,
		});
	};

	_addTempSensorToBox = async () => {
		if (!this.state.selectedTempSensor) {
			toasts.show('Please select a temperature sensor first');
			return;
		}

		if (!this.props.drugBoxId) {
			toasts.show('Drug box ID is required');
			return;
		}

		try {
			// Add the temperature sensor to the drug box
			const result = await mainAPI.drug_box.update({
				id: this.props.drugBoxId,
				sensor_id: this.state.selectedTempSensor.id
			});

			if (result) {
				toasts.show('Temperature sensor added successfully');
				this.setState({ 
					selectedTempSensor: null,
					availableTempSensors: [],
					showTempSensorDropdown: false 
				});
				
				// Notify parent component that a sensor was added
				if (this.props.onSensorAdded) {
					this.props.onSensorAdded(this.state.selectedTempSensor);
				}
				
				// Close the popup
				this.props.onClose();
			} else {
				toasts.show('Failed to add temperature sensor');
			}
		} catch (error) {
			console.error('Error adding temperature sensor:', error);
			toasts.show('Error adding temperature sensor');
		}
	};

	render() {
		let show = this.props.show;
		if (!this.props.hasOwnProperty('show')) {
			show = true;
		}

		return (
			<Popup {...this.props} show={show} className="g-temperature-sensor-popup">
				<Card>
					<FontIcon className="close-icon" onClick={this.props.onClose} name="icon-close" />
					<Label large black center>
						Add Temperature Sensor
					</Label>
					
					<div className="temp-sensor-content">
						<PrimaryButton
							center
							className="scan-temp-sensors"
							onClick={this._scanForTempSensors}
						>
							Scan for Sensors
						</PrimaryButton>
						
						{this.state.showTempSensorDropdown && (
							<div className="temp-sensor-dropdown">
								<Label black bold>Available Temperature Sensors:</Label>
								<UniversalDropDown 
									options={this.state.availableTempSensors}
									placeholder="Select a temperature sensor"
									onChange={this._onTempSensorSelect}
								/>
								{this.state.selectedTempSensor && (
									<PrimaryButton
										className="add-temp-sensor" 
										color="white" 
										bg="blue" 
										onClick={this._addTempSensorToBox}
									>
										Add Selected Sensor
									</PrimaryButton>
								)}
							</div>
						)}
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/temperatureSensorPopup/TemperatureSensorPopup.jsx